import React from 'react';

import { SERVER_ERROR_MODAL_TEXT, SERVER_ERROR_MODAL_TITLE } from '@/common/constants';
import { WarnModal } from '@/components/elements';

interface Props {
  onSubmit: () => void;
  onSetVisible: (value: boolean) => void;  
}

const ProvideFullAccessErrorModal: React.FC<Props> = ({ onSubmit, onSetVisible }) => (
  <WarnModal
    testId="provide-full-access-error"
    visible
    onSetVisible={onSetVisible}
    header={SERVER_ERROR_MODAL_TITLE}
    helptext={SERVER_ERROR_MODAL_TEXT}
    buttonText="Close"
    onSubmit={onSubmit}
    submitButtonText="Try again"
    isAwaitMode
    disableAutomaticClosing
  />
);

export default ProvideFullAccessErrorModal;
